import { postToast, ToastType } from "../postToast/postToast.use-case";
import { createAppAsyncThunk } from "core/src/store/store.types";

export type DisplayFrontErrorToastRequest = unknown | string | { message: string };

export const displayFrontErrorToast = createAppAsyncThunk<void, DisplayFrontErrorToastRequest>(
	"ui/displayFrontErrorToast",
	(error, { dispatch }) => {
		const messages: string[] = [];

		/**
		 * Compute error message
		 */
		if (typeof error === "string") {
			messages.push(error as string);
		} else if (error && typeof error === "object" && "message" in error) {
			messages.push((error as { message: string }).message);
		} else if (typeof error === "object" && error != null) {
			messages.push(error.toString().replace("Error: ", ""));
		}

		/**
		 * display error message
		 */
		if (messages.length > 0) {
			messages.forEach((msg: string) => {
				if (msg.length > 0) {
					dispatch(postToast({ type: ToastType.ERROR, message: msg }));
				}
			});
		}
	}
);
